import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  favorites: [],
  favoritesFetched: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_FAVORITES_DATA:
      return { ...state, favorites: action.data || [] };
    case actionTypes.SET_ACTIVITIES:
      return { ...state, activities: action.data };
    case actionTypes.SET_FETCH_COMPLETED:
      return { ...state, favoritesFetched: action.data || false };
    default:
      return state;
  }
};
